// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Libre Caslon Text', 'Libre Caslon Text Fallback'"},"className":"__className_052fe8"};